export default __webpack_public_path__ + "static/media/utility-icon.fb403c3b.png";